export enum OnlineCollectionPaymentRequestTypeEnum {
  ORDER = "ORDER",
  WALLET = "WALLET"

}
